import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import Navbar from "./Navbar";
import GetLogo from "./GetLogo";
import { useLanguage } from "./Langs";

const PageNotFound = (props) => {
  let [openHelp, setOpenHelp] = React.useState(false);

  let logo = GetLogo();
  const [lang, setLang] = useLanguage();

  return (
    <div>
      <Navbar
        lang={[lang, setLang]}
        disableToolBar
        openHelp={openHelp}
        setOpenHelp={setOpenHelp}
        color={logo.color}
        helpColor={logo.helpColor}
        banner={logo.banner}
      ></Navbar>

      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.13.0/css/all.css"
        integrity="sha384-Bfad6CLCknfcloXFOyFnlgtENryhrpZCe29RTifKEixXQZ38WheV+i/6YWSzkz3V"
        crossOrigin="anonymous"
      />

      <div
        className="container404"
        style={{
          textAlign: "center",
          margin: "0 auto",
          marginTop: "100px",
          paddingBottom: "50px",
          backgroundColor: "white",
          border: "black solid 3px",
          borderRadius: "40px",
          borderColor: "transparent",
          boxShadow: "10px 10px 5px rgba(1, 1, 1, 0.5)",
        }}
      >
        <div className="col-md-12" style={{}}>
          <div
            className="error-template"
            style={{
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: "48px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {lang.Oops}
            </p>
            <hr
              style={{
                width: "100%",
                display: "block",
                margin: "auto",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            ></hr>
            <h2 style={{ textAlign: "center" }}>{lang.NotFound}</h2>
            <div
              className="error-details"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              <b>{lang.SorryError}</b>
            </div>
            <div className="error-actions">
              <a
                href={`/access/${logo.logo}`}
                className="btn btn-primary btn-lg"
                style={{ marginRight: "10px" }}
              >
                <span className="glyphicon glyphicon-home">
                  <HomeIcon></HomeIcon>
                </span>
                {lang.TakeMeHome}{" "}
              </a>
              <a
                href="mailto:info@myshs.com"
                className="btn btn-default btn-lg"
                style={{
                  border: "1px solid black",
                  borderRadius: "5px",
                  backgroundColor: "white",
                }}
              >
                <span className="glyphicon glyphicon-envelope">
                  <EmailIcon></EmailIcon>
                </span>{" "}
                {lang.ContactSupport}{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
      <p style={{ textAlign: "center", margin: "50px", marginTop: "40px" }}>
        {lang.Experience}: <br></br>
        <a href="mailto:info@myshs.com">info@myshs.com</a>
      </p>
    </div>
  );
};
export default PageNotFound;
